import {
  Radio,
  Link,
  Layout,
  Message,
  Typography,
} from "@visma-netvisor/react-component-library";
import { useFormContext } from "react-hook-form";
import { getLanguageId, LanguageId } from "../../i18";
import { FormInputs } from "../Content";
import { StarFilledIcon } from "@visma-netvisor/nv-react-icons";
import { Trans, useTranslation } from "react-i18next";
import { activateNewCompanyCampaign } from "../../Domain/NewCampaign";
import { sendGACampaignSelect } from "../../googleAnalytics";
import { useContext } from "react";
import styled from "styled-components";
import { PricesContext } from "../../pricesContext";

const CampaignOptions = styled(Layout.Flex)`
  label > span {
    overflow: visible;
  }
`;

export const AdContainer = () => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState,
  } = useFormContext<FormInputs>();

  const { i18n } = useTranslation();
  const language = i18n.language;
  const languageId = getLanguageId(language);
  const prices = useContext(PricesContext);

  const newCompanyInfoLink = 
    languageId === LanguageId.Finnish
      ? "https://netvisor.fi/wp-content/uploads/2026/01/Uudet-yritykset-2026-kampanjan-ehdot-ja-saannot.pdf"
      : "https://netvisor.fi/wp-content/uploads/2026/01/Terms-and-conditions-of-the-new-companies-campaign-2026.pdf";

  return (
    <Message
      fullWidth
      variant="info"
      iconOverride={<StarFilledIcon />}
    >
      <Typography
        as="h4"
        color="info"
        styleOverrides={{ marginBottom: 8 }}
        variant="headingH4Bold"
      >
        {t("CompanyInformation.AdTitle")}
      </Typography>
      <Typography
        as="p"
        color="info"
        styleOverrides={{ marginBottom: 8 }}
        variant="contentHeadingH4Regular"
      >
        {t("CompanyInformation.AdDescription1")}
      </Typography>
      <Typography
        as="p"
        color="info"
        styleOverrides={{ marginBottom: 8 }}
        variant="contentHeadingH4Regular"
      >
        <Trans
          i18nKey="CompanyInformation.AdLink"
          components={[
            <Link
              target="_blank"
              style={{ cursor: "pointer" }}
              href={newCompanyInfoLink}
            ></Link>
          ]}
        />
      </Typography>
      <Typography
        as="p"
        color="info"
        styleOverrides={{ marginBottom: 8 }}
        variant="contentHeadingH4Regular"
      >
        {t("CompanyInformation.AdCampaignUseBenefitText")}
      </Typography>
      <CampaignOptions flexDirection="column" flexGap={0}>
        <Radio
          label={t("CompanyInformation.AdChangePacket")}
          name="activate"
          onChange={(e) => {
            e.preventDefault();
            sendGACampaignSelect(prices);
            activateNewCompanyCampaign(watch(), formState);
          }}
          value={0}
        ></Radio>
        <Radio
          { ...register("newCompanyCampaignOptOut", { required: true })}
          label={t("CompanyInformation.AdDeclineCampaign")}
          value={1}
        ></Radio>
      </CampaignOptions>
    </Message>
  );
};

export default AdContainer;
